import { render, staticRenderFns } from "./DirectionChoose.vue?vue&type=template&id=23d51dea&scoped=true&"
import script from "./DirectionChoose.vue?vue&type=script&lang=js&"
export * from "./DirectionChoose.vue?vue&type=script&lang=js&"
import style0 from "./DirectionChoose.vue?vue&type=style&index=0&id=23d51dea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d51dea",
  null
  
)

export default component.exports